module.exports = __webpack_public_path__ + "img/x431_4.987adcd5.jpg";